export default __webpack_public_path__ + "static/media/github_thumb.1ff6d964.png";